module.exports = __webpack_public_path__ + "static/media/pestec.bc8d471d.pdf";